<script setup lang="ts">
import { faArrowLeft, faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { NuxtLink } from '#components';

const layoutStore = useLayoutStore();
const { inProcessFloatings } = classToRefs(layoutStore);
const hotelSearch = computed(() => useRoute().path.includes('hotel'));

onMounted(() => layoutStore.getFloatingsInProcess());
</script>
<template>
    <NuxtLink
        v-if="inProcessFloatings.length && hotelSearch"
        :to="`/reserve/floating?billCode=${inProcessFloatings[0].billCode}&mac=${inProcessFloatings[0].mac}`"
        class="auto-reserve-root"
    >
        <mr-icon :icon="faSpinner" color="var(--blue-500)" pulse />
        <mr-typography weight="500" color="var(--blue-500)" grow>
            شما {{ inProcessFloatings.length }} شناوری فعال دارید.
        </mr-typography>
        <mr-icon :icon="faArrowLeft" color="var(--blue-500)" />
    </NuxtLink>
</template>

<style lang="scss" scoped>
.auto-reserve-root {
    display: flex;
    gap: 8px;
    align-items: center;
    background-color: usePalette($p-blue, $p-100);
    padding: 12px 16px;
}
</style>
